<template>
   <div class="tabWarp">
    <div class="topBox">
      <DomainInput @setDomain="setDomain"></DomainInput>
    </div>
    <el-table v-loading="loading" :header-cell-style="{background:'#EEF5FF',color:'#566087'}" ref="projectTable"
      tooltip-effect="dark" style="width:100%" :data="data">
      <template slot="empty">
        <div id="notDate">
          <img src="../../../assets/imgs/memory/no_data.png" alt />
          <p>暂无数据</p>
        </div>
      </template>
      <el-table-column align="center" label="项目名称" :show-overflow-tooltip="true" prop="projectName"></el-table-column>
      <el-table-column align="center" label="翻译流畅度" :show-overflow-tooltip="true" prop="fluencyScore"></el-table-column>
      <el-table-column align="center" label="翻译准确度" :show-overflow-tooltip="true" prop="accuracyScore">
      </el-table-column>
      <el-table-column align="center" label="审   校" :show-overflow-tooltip="true" prop="createAliasName">
        <template slot-scope="scope">
          <div>
           {{ scope.row.createAliasName || "--"}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="语言对" :show-overflow-tooltip="true" prop="langDesc" min-width="123">
      </el-table-column>
      <el-table-column align="center" label="领   域" :show-overflow-tooltip="true" prop="domainName" min-width="123">
      </el-table-column>
      <el-table-column align="center" label="日   期" :show-overflow-tooltip="true" prop="taskFinishTime" min-width="123">
      </el-table-column>
    </el-table>

    <div class="paging_device">
      <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
        :pager-count="5" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import DomainInput from "@/common/Statistics/InterpreterStatistics/DomainInput";
import tabMixin from "./tabMixin";
export default {
  props: {

  },
  mixins: [tabMixin],
  data() {
    return {
      loading: false,
      data: [],
      activeBtn: true,
      date: "",
    };
  },
  components: {
    DomainInput,

  },
  created() {
   this.getPage()
  },
  mounted() {

  },
  methods: {
    async getPage() {
      let url = "/api/v1/taskScore/queryPage"
      var params = {
        filter: {
          companyCode: localStorage.myCompanyCode,
          taskUserId: this.$route.query.id,
          domainCode:this.domainCode
        },
        page: this.currentPage,
        rows: this.rows
      };
      const { resultCode, list, totalRows } = await this.catReq1Service(url, params)
      if (resultCode === '1') {
        list.forEach(item => {
          item.taskFinishTime = this.dateReg(item.taskFinishTime)
        });
        this.data = list;
        this.totalRows = totalRows
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./common.less";
.topBox {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  margin-bottom: 14px;
}
</style>
